import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';

type TableSkeletonProps = {
  rows?: number;
};

const useStyles = makeStyles(() =>
  createStyles({
    skeletonRadius: {
      borderRadius: 16,
    },
  }),
);

const TableSkeleton = ({ rows = 2 }: TableSkeletonProps) => {
  const classes = useStyles();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={2}>
          <Skeleton
            classes={{
              text: classes.skeletonRadius,
            }}
            animation="wave"
            variant="text"
            width="100%"
            height={40}
          />
        </Grid>
        <Grid item xs={2}>
          <Skeleton
            classes={{
              text: classes.skeletonRadius,
            }}
            animation="wave"
            variant="text"
            width="100%"
            height={40}
          />
        </Grid>
        <Grid item xs={2}>
          <Skeleton
            classes={{
              text: classes.skeletonRadius,
            }}
            animation="wave"
            variant="text"
            width="100%"
            height={40}
          />
        </Grid>
        <Grid item xs={6}>
          {/* <Skeleton animation="wave" width="100%" height={20} /> */}
        </Grid>
      </Grid>

      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Skeleton animation="wave" width="100%" height={100} />
        </Grid>

        {Array.apply(0, Array(rows)).map((_, index) => (
          <Grid key={index} item xs={12}>
            <Skeleton animation="wave" width="100%" height={60} />
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={1} justify="flex-end">
        <Grid item xs={1}>
          <Skeleton animation="wave" width="100%" height={50} />
        </Grid>
        <Grid item xs={1}>
          <Skeleton animation="wave" width="100%" height={50} />
        </Grid>
        <Grid item xs={1}>
          <Skeleton animation="wave" width="100%" height={50} />
        </Grid>
        <Grid item xs={1}>
          <Skeleton animation="wave" width="100%" height={50} />
        </Grid>
      </Grid>
    </>
  );
};

export default TableSkeleton;
